import React from "react";
import "../ResultScreen.css";

interface ResultScreenLayoutProps {
  children: React.ReactNode;
}

const ResultScreenLayout: React.FC<ResultScreenLayoutProps> = ({ children }) => {
  return (
    <div className="result-screen-overlay">
      <div className="result-screen">
        {children}
      </div>
    </div>
  );
};

export default ResultScreenLayout;

